module.exports = "<div *ngIf=\"visibleFunc()\" id=\"modal\" [ngClass]=\"{'modal' : !newModal, 'new-modal': newModal }\">\n  <div class=\"modal-content\">\n    <button *ngIf=\"exibeButtonClose\" (click)=\"hide()\" class=\"btn-close-modal\">X</button>\n    <ng-content></ng-content>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/modal/modal.component.html
// module id = ./src/app/components/modal/modal.component.html
// module chunks = main